module.exports = __webpack_public_path__ + "img/bianji_bai.48fb1b56.svg";